import VueRouter from 'vue-router'
import { RouterUtil, StorageUtil, RequestTokenQueryKey, EnvUtil, BrowserUtil } from 'kuaidong-lib'

const WXWebOauthTargetHash = 'wx-web-oauth-target-hash'

export class BaseLoginService {
  public static LoginPhoneTmpKey = '__lptk_220320__'
  public static LoginAccountTmpKey = '__latk_220410__'
  public static RequestTokenQueryKey = RequestTokenQueryKey

  public static setTmpPhone(phone: string) {
    StorageUtil.set(BaseLoginService.LoginPhoneTmpKey, phone, 60 * 60 * 24)
  }

  public static getTmpPhone() {
    return StorageUtil.getAndRemove(BaseLoginService.LoginPhoneTmpKey) || ''
  }

  public static setTmpAccount(account: string) {
    StorageUtil.set(BaseLoginService.LoginAccountTmpKey, account, 60 * 60 * 24)
  }

  public static getTmpAccount() {
    return StorageUtil.getAndRemove(BaseLoginService.LoginAccountTmpKey) || ''
  }

  public static buildWXWebOauthUrlFromHref(_href: string) {
    const targetStr = this.encodeWXWebOauthTargetHash(_href)
    const apiHost = 'api.tiantiantiaosheng.com'
    if (EnvUtil.isApph5()) {
      return `https://${apiHost}/api/ttts/wx_web_oauth_entry?target=${targetStr}&scope=snsapi_base`
    }
    return `https://${apiHost}/api/wx_web_oauth_entry?target=${targetStr}&scope=snsapi_base`
  }

  public static buildWXWebOauthUrl(
    _route: { name?: string | null; path?: string | null },
    _query: { [index: string]: string | (string | null)[] } | null = null,
    router?: VueRouter
  ) {
    return this.buildWXWebOauthUrlFromHref(RouterUtil.buildUrlFromRoute(_route, _query, router))
  }

  /**
   * 微信内整页跳转 snsapi_base 授权拿 openid。
   * XHR 会 CORS；iframe 里授权页只回 200 HTML、不 302，都拿不到 code。
   * 各业务端如需"已绑定则跳过"，可在子类覆写（如 campus）。
   * @returns true 表示已发起跳转，调用方勿再改 location / router
   */
  public static async requestWxOpenId(_href = location.href): Promise<boolean> {
    if (!BrowserUtil.isWechatOfficial()) {
      return false
    }

    location.href = this.buildWXWebOauthUrlFromHref(_href)
    return true
  }

  public static setTokenCookie(token: string): void {
    const maxAge = 30 * 60
    const cookieName = EnvUtil.isCampus() || EnvUtil.isSaas() ? 'ttts_user_token' : 'ttts_user_token_debug'
    const cookie = `${cookieName}=${token};domain=tiantiantiaosheng.com;path=/;max-age=${maxAge}`
    document.cookie = cookie
  }

  public static hasWXWebOauthTargetHash(href: string) {
    return href && href.includes(WXWebOauthTargetHash)
  }

  public static encodeWXWebOauthTargetHash(href: string) {
    const url = new URL(href)
    if (url.hash) {
      localStorage.setItem(WXWebOauthTargetHash, url.hash)

      return `${url.origin}${url.pathname}?${WXWebOauthTargetHash}`
    } else {
      return href
    }
  }

  public static decodeWXWebOauthTargetHash(href: string) {
    if (this.hasWXWebOauthTargetHash(href)) {
      const url = new URL(href)
      const hash = localStorage.getItem(WXWebOauthTargetHash) || ''

      url.searchParams.delete(WXWebOauthTargetHash)

      if (hash) {
        let path = hash

        if (url.search) {
          if (path.includes('?') && url.search.startsWith('?')) {
            path = `${path}&${url.search.substring(1)}`
          } else {
            path = `${path}${url.search}`
          }
        }

        return `${url.origin}${url.pathname}${path}`
      } else {
        return `${url.origin}${url.pathname}#/home${url.search}`
      }
    }

    return href
  }
}
